import { render, staticRenderFns } from "./blog_details.vue?vue&type=template&id=5b37b4fc"
import script from "./blog_details.vue?vue&type=script&lang=js"
export * from "./blog_details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports